export const latestVersions = {
    pyramid: 'pyramid-1.1',
    story: 'story-0.0'
}